<template>
    <span>
        <loading  :active.sync="isLoading"
                  :is-full-page="fullPage"
        ></loading>
        <slot></slot>
        <div>
            <table class="table">
                <thead>
                <tr>
                    <th class="col-xs-3">日期</th>
                    <th class="col-xs-3">假別</th>
                    <th class="col-xs-2">原時數</th>
                    <th class="col-xs-2">修改時數</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, key) of dates">
                    <td>
                        {{ row.date }}
                    </td>
                    <td>
                        {{ typeOptions[row.type] }}
                    </td>
                    <td>
                        {{ originalDuration[key] }}小時
                    </td>
                    <td>
                        <input type="number" min="0" max="8" step="1" v-bind:value="dates[key].duration/3600" v-on:input="updateDuration($event, key)">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="hidden hidden-input">
            <table>
                <tr v-for="(data, key) in dates">
                    <td v-for="(column, name) in data">
                        <label>{{ name }}
                            <input type="text" v-model="dates[key][name]" :name="generateName(name, [key, name])">
                        </label>
                    </td>
                </tr>
            </table>
        </div>
    </span>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Axios from 'axios';

  export default {
    computed: {
    },
    props: {
      'default-value': {
        type: Array,
        default: [],
      },
      'original-value': {
        type: Array,
        default: [],
      },
      'type-options': {
        type: Object,
        default: [],
      },
      'current-dayoff-uuid': {
        type: String,
        default: '',
      },
      'user-uuid': {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        dates: [],
        name: 'dayoff_dates',
        isLoading: false,
        fullPage: false,
        originalDuration: [],
      };
    },
    mounted() {
      this.loadDefaultValue();
      this.setOriginalDuration();
    },
    updated() {
    },
    methods: {
      loadDefaultValue: function () {
        if (this.defaultValue.length > 0) {
          this.defaultValue.forEach((item) => {
            this.dates.push(item);
          });
        }
      },
      setOriginalDuration: function () {
        this.originalValue.forEach((date) => {
          let durationDisplay = Math.floor(date.duration * 100 / 3600) / 100;
          this.originalDuration.push(durationDisplay);
        });
      },
      generateName: function (name, pathes) {
        let inputName = this.name;

        pathes.forEach((item) => {
          inputName += '[' + item + ']';
        });

        return inputName;
      },
      updateDuration: function ($event, key) {
        let value = $event.target.value;

        value = Math.min(8, value, this.originalDuration[key]);
        value = Math.max(0, value);

        this.dates[key].duration = Math.round(value * 3600);
        this.$forceUpdate();
      }
    },
    watch: {
      value: function (value) {
        if (value.length === 0) {
          this.addRow();
        }
      },
    },
    components: {
      Loading,
    }
  }
</script>
